export var InvestmentOpportunitySortKey;
(function (InvestmentOpportunitySortKey) {
    InvestmentOpportunitySortKey["OpenDateAsc"] = "openDateAsc";
    InvestmentOpportunitySortKey["OpenDateDesc"] = "openDateDesc";
    InvestmentOpportunitySortKey["ScheduledCloseDateAsc"] = "scheduledCloseDateAsc";
    InvestmentOpportunitySortKey["ScheduledCloseDateDesc"] = "scheduledCloseDateDesc";
    InvestmentOpportunitySortKey["NameAsc"] = "nameAsc";
    InvestmentOpportunitySortKey["NameDesc"] = "nameDesc";
})(InvestmentOpportunitySortKey || (InvestmentOpportunitySortKey = {}));
//# sourceMappingURL=index.js.map